import { Link } from "react-router-dom";
import { fileUrl, money } from "@/lib/api";

export function ProductCard({ product, index = 0 }) {
  const img = product.images?.[0];
  const soldOut = product.sold_out;
  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group block animate-fade-up"
      style={{ animationDelay: `${Math.min(index * 60, 360)}ms` }}
    >
      <div className="hover-zoom relative overflow-hidden rounded-md border border-kys-blush-border bg-kys-blush">
        <div className="aspect-[3/4] w-full overflow-hidden">
          {img ? (
            <img src={fileUrl(img)} alt={img.alt || product.name} loading="lazy" className="h-full w-full object-cover" />
          ) : (
            <div className="flex h-full w-full items-center justify-center text-kys-muted">No photo</div>
          )}
        </div>
        {soldOut && (
          <span className="absolute left-3 top-3 rounded-full bg-kys-ink px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-white">
            Sold Out
          </span>
        )}
      </div>
      <div className="mt-3 flex items-start justify-between gap-2">
        <h3 className="text-sm font-medium leading-snug text-kys-ink transition group-hover:text-kys-accent">{product.name}</h3>
        <span className="whitespace-nowrap font-mono text-sm text-kys-charcoal">{money(product.price)}</span>
      </div>
    </Link>
  );
}
